import axios from 'axios';
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';

const Form = () => {
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const [submitting, setSubmitting] = useState(false);
    const [toast, setToast] = useState(null);
    const [newPet, setNewPet] = useState({
        name: "",
        type: "",
        description: "",
        skill1: "",
        skill2: "",
        skill3: ""
    });

    const showToast = (message, type = 'success') => {
        setToast({ message, type });
        setTimeout(() => setToast(null), 3000);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitting(true);
        setErrors({});

        axios.post(`http://localhost:8000/api/new`, newPet)
            .then(res => {
                console.log(res);
                showToast('Pet added successfully! 🎉', 'success');
                setTimeout(() => {
                    navigate('/');
                }, 1500);
            })
            .catch(err => {
                console.log(err.response.data.errors);
                setErrors(err.response.data.errors);
                showToast('Please fix the errors below', 'error');
                setSubmitting(false);
            });
    };

    return (
        <div className='app-container fade-in'>
            {toast && (
                <div className="toast-container">
                    <div className={`toast ${toast.type}`}>
                        <span className="toast-icon">
                            {toast.type === 'success' ? '✅' : '❌'}
                        </span>
                        <span className="toast-message">{toast.message}</span>
                    </div>
                </div>
            )}

            <div className="navbar navbar-light">
                <h1>Pet Shelter</h1>
                <Link to={'/'}>back to home</Link>
            </div>

            <h3>Know a pet needing a home?</h3>

            <div className="form-container scale-in">
                <form onSubmit={handleSubmit}>
                    <div className='form-grid'>
                        <div className='form-section'>
                            <div className="form-group">
                                <label className="required">Pet Name</label>
                                <input 
                                    className='form-control' 
                                    type='text' 
                                    placeholder='e.g., Max, Bella, Charlie'
                                    value={newPet.name}
                                    onChange={e => setNewPet({...newPet, name: e.target.value})}
                                />
                                {errors.name && <p className='error'>{errors.name.message}</p>}
                            </div>

                            <div className="form-group">
                                <label className="required">Pet Type</label>
                                <input 
                                    className='form-control' 
                                    type='text'
                                    placeholder='e.g., Dog, Cat, Rabbit'
                                    value={newPet.type}
                                    onChange={e => setNewPet({...newPet, type: e.target.value})}
                                />
                                {errors.type && <p className='error'>{errors.type.message}</p>}
                            </div>

                            <div className="form-group">
                                <label className="required">Pet Description</label>
                                <input 
                                    className='form-control' 
                                    type='text'
                                    placeholder='Tell us about this wonderful pet...'
                                    value={newPet.description}
                                    onChange={e => setNewPet({...newPet, description: e.target.value})}
                                />
                                {errors.description && <p className='error'>{errors.description.message}</p>}
                            </div>

                            <button 
                                type="submit" 
                                className="btn btn-primary"
                                disabled={submitting}
                            >
                                {submitting ? 'Adding Pet...' : 'Add Pet'}
                            </button>
                        </div>

                        <div className='form-section'>
                            <span className="form-section-header">Skills (Optional)</span>
                            
                            <div className="form-group">
                                <label>Skill 1</label>
                                <input 
                                    className='form-control' 
                                    type='text'
                                    placeholder='e.g., Fetching'
                                    value={newPet.skill1}
                                    onChange={e => setNewPet({...newPet, skill1: e.target.value})}
                                />
                            </div>

                            <div className="form-group">
                                <label>Skill 2</label>
                                <input 
                                    className='form-control' 
                                    type='text'
                                    placeholder='e.g., Sitting'
                                    value={newPet.skill2}
                                    onChange={e => setNewPet({...newPet, skill2: e.target.value})}
                                />
                            </div>

                            <div className="form-group">
                                <label>Skill 3</label>
                                <input 
                                    className='form-control' 
                                    type='text'
                                    placeholder='e.g., Rolling over'
                                    value={newPet.skill3}
                                    onChange={e => setNewPet({...newPet, skill3: e.target.value})}
                                />
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Form;